"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1608],{

/***/ 31608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(4730);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(27812);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(31555);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(10682);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_newsCard_readNews__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65627);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2185);
/* harmony import */ var redux_actions_ads_Actions__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(8969);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var redux_actions_categoryActions__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(20336);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30719);
/* harmony import */ var debounce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20296);
/* harmony import */ var debounce__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(debounce__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(965);
/* harmony import */ var pages_404__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7725);
/* harmony import */ var localization_i8intl__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(54269);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(44012);
/* harmony import */ var react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(58533);
/* harmony import */ var api_constants__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(9041);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(2962);
/* harmony import */ var _constants_metaTags__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(89195);
/* harmony import */ var api_cleverTap__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(81511);
/* harmony import */ var api_commonConstants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(96781);
/* harmony import */ var components_elections_2023_ElectionsWidget__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(38562);
/* harmony import */ var components_faq__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(74892);
/* harmony import */ var constants_MasterConfigContext__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(39712);
/* harmony import */ var components_tally_Tally__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(5317);
/* harmony import */ var constants_state__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(25613);
/* harmony import */ var _Ads_index__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(99126);
/* harmony import */ var components_cricket_Strip__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(34997);
/* harmony import */ var components_cricket_WidgetHome__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(70014);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(85893);




var _excluded = ["subCategoryId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

























 // import Slider from "react-slick";












var DynamicBanner = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 6328).then(__webpack_require__.bind(__webpack_require__, 43057));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(43057)];
    }
  }
});
var NewsImageTextBanner1 = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(1818), __webpack_require__.e(6677), __webpack_require__.e(5508)]).then(__webpack_require__.bind(__webpack_require__, 36677));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(36677)];
    }
  }
}); // const CricketSlider = dynamic(
//   () => import("../../components/homePage/cricketSlider"),
//   { ssr: true }
// );
// const ReactJWPlayer = dynamic(() => import("react-jw-player"), { ssr: true });

var CommonCategoryPage = function CommonCategoryPage(_ref) {
  var _useContext, _router$query3, _newsData$, _newsData$2, _electionStuff$, _electionStuff$2, _stateData$subCategor;

  var newsData = _ref.newsData,
      categoryName = _ref.categoryName,
      subCategoryName = _ref.subCategoryName,
      liveBlogData = _ref.liveBlogData,
      seoData = _ref.seoData,
      _ref$electionTopicDat = _ref.electionTopicData,
      electionTopicData = _ref$electionTopicDat === void 0 ? [] : _ref$electionTopicDat,
      _ref$metaDetails = _ref.metaDetails,
      metaDetails = _ref$metaDetails === void 0 ? {} : _ref$metaDetails,
      faqData = _ref.faqData,
      articlePageBanners = _ref.articlePageBanners,
      breadCrump = _ref.breadCrump,
      fromRoot = _ref.fromRoot,
      propData = _ref.propData,
      pointsData = _ref.pointsData,
      scoreData = _ref.scoreData;

  // const [canScrollLeft, setCanScrollLeft] = useState(false);
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      canScrollRight = _useState[0],
      setCanScrollRight = _useState[1];

  var STATIC_BREADCRUMP = [{
    displayText: "कौन जीता-कौन हारा",
    url: "/election/delhi-assembly-chunav/results",
    keyToShow: "Delhi_KaunJeeta"
  }, {
    displayText: "प्रमुख उम्मीदवार",
    url: "/election/delhi-assembly-chunav/key-candidates",
    keyToShow: "DelhiKeyCandidate"
  }, {
    displayText: "एग्जिट पोल",
    url: "/election/delhi-assembly-chunav/exit-poll",
    keyToShow: "DelhiExitPollPage"
  }, {
    displayText: "विधान सभा रिजल्ट",
    url: "/election/delhi-assembly-chunav/party-wise-result",
    keyToShow: "DelhiResultPage"
  }, {
    displayText: "शेड्यूल",
    url: "/election/delhi-assembly-chunav/schedule",
    keyToShow: "DelhiSchedulePage"
  }, {
    displayText: "सामान्य प्रश्न",
    url: "/election/assembly-chunav/faq",
    keyToShow: ""
  }]; // const masterConfig = useContext(MasterConfigContext)?.vidhansabha_election;

  var masterConfig = (_useContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(constants_MasterConfigContext__WEBPACK_IMPORTED_MODULE_22__/* .MasterConfigContext */ .d)) === null || _useContext === void 0 ? void 0 : _useContext[propData !== null && propData !== void 0 && propData.masterConfigKey ? propData.masterConfigKey : "Delhi_vidhansabha_election"];
  var masterConfigCT = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(constants_MasterConfigContext__WEBPACK_IMPORTED_MODULE_22__/* .MasterConfigContext */ .d); // const maharashtraMasterConfig = useContext(MasterConfigContext)

  console.log("Masterconfig articlePageBanners ", articlePageBanners);
  var data = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function (data) {
    var _data$CategoryReducer;

    return data === null || data === void 0 ? void 0 : (_data$CategoryReducer = data.CategoryReducer) === null || _data$CategoryReducer === void 0 ? void 0 : _data$CategoryReducer.subCategoryItem;
  });

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
      electionStuff = _useState2[0],
      setElectionStuff = _useState2[1];

  var size = (0,api_commonConstants__WEBPACK_IMPORTED_MODULE_19__/* .useWindowSize */ .iP)();
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
      var x = data.filter(function (x) {
        return x.slug === "elections-2023";
      });

      if (x) {
        setElectionStuff(x);
      }
    }
  }, [data]);
  var padtaalStaticHeadings = ["हमारे बारे में", "पड़ताल का तरीका", "भूल सुधार", "कॉन्टेक्ट", "शिकायत"];
  var padtaalStaticHeadingsEng = ["About Us", "Methodology", "Correction Policy", "Contact", "Complaints"];
  var padtaalStaticHeadingsUrl = ["factcheck-about-us", "factcheck-methodology", "factcheck-correction-policy", "factcheck-contact-us", "factcheck/complaints"];
  var query = router.query; // const pageToOpen = router?.pathname.includes("/all")
  //   ? "video,text,liveblog"
  //   : router?.pathname.includes("/text")
  //   ? "text,liveblog"
  //   : "video";
  // const pageToOpen = router?.pathname.includes("/text")
  // ? "text,liveblog"
  // : "video";

  var pageToOpen = router !== null && router !== void 0 && router.pathname.includes("/text") ? "text,liveblog" : router !== null && router !== void 0 && router.pathname.includes("/video") ? "video" : "video,text,liveblog"; // const mainUrl = router?.pathname.includes("/text")
  //   ? "text"
  //   : router?.pathname.includes("/video")
  //   ? "video"
  //   : "";

  var mainUrl = "";

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(newsData),
      posts = _useState3[0],
      setPosts = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true),
      hasMore = _useState4[0],
      setHasMore = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(3),
      skipPerPage = _useState5[0],
      setSkipPerPage = _useState5[1]; // const [electionTopicData, setElectionTopicData] = useState([]);


  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      firstScroll = _useState6[0],
      setFirstScroll = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""),
      showMetaTitleFromApi = _useState7[0],
      setShowMetaTitleFromApi = _useState7[1];

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""),
      showMetaKeywordFromApi = _useState8[0],
      setShowMetaKeywordFromApi = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""),
      showMetaDescriptionFromApi = _useState9[0],
      setShowMetaDescriptionFromApi = _useState9[1]; // const [cricketResponse, setCricketResponse] = useState([]);
  // useEffect(async () => {
  //   if (categoryName === "sports") {
  //     let cricketResponse1;
  //     try {
  //       const cricketResult = await fetch(
  //         "https://production-rest-microservice.thesportstak.com/english/api/v2/featureCard/home"
  //       );
  //       cricketResponse1 = await cricketResult?.json();
  //       cricketResponse1 = cricketResponse1?.response?.items;
  //       setCricketResponse(cricketResponse1);
  //       console.log("try cricket11post");
  //     } catch (error) {
  //       setCricketResponse("");
  //       console.log("catch cricket11post");
  //     }
  //   }
  // }, [categoryName]);


  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (firstScroll) {
      // console.log("Inside here");
      setTimeout(function () {
        window._taboola = window._taboola || [];

        _taboola.push({
          mode: "alternating-thumbnails-a",
          container: "taboola-below-category-thumbnails",
          placement: "Below Category Thumbnails",
          target_type: "mix"
        });

        window._taboola = window._taboola || [];

        _taboola.push({
          category: "auto"
        });

        !function (e, f, u, i) {
          if (!document.getElementById(i)) {
            e.async = 1;
            e.src = u;
            e.id = i;
            f.parentNode.insertBefore(e, f);
          }
        }(document.createElement("script"), document.getElementsByTagName("script")[0], "//cdn.taboola.com/libtrc/indiatoday-thelallantop/loader.js", "tb_loader_script");

        if (window.performance && typeof window.performance.mark == "function") {
          window.performance.mark("tbl_ic");
        }

        (function () {
          var _router$query;

          /* CONFIGURATION START */
          var _sf_async_config = window._sf_async_config = window._sf_async_config || {};

          _sf_async_config.uid = 60355;
          _sf_async_config.domain = "thelallantop.com";
          _sf_async_config.useCanonical = true;
          _sf_async_config.useCanonicalDomain = true;
          _sf_async_config.sections = "".concat(router.pathname.includes("latest") ? "latest" : categoryKeyword || ((_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.categoryName));
          _sf_async_config.authors = "";
          /* CONFIGURATION END */

          function loadChartbeat() {
            var e = document.createElement("script");
            var n = document.getElementsByTagName("script")[0];
            e.type = "text/javascript";
            e.async = true;
            e.src = "//static.chartbeat.com/js/chartbeat.js";
            n.parentNode.insertBefore(e, n);
          }

          loadChartbeat();
        })();
      }, 10);
    }
  }, [firstScroll, newsData]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    setPosts(newsData);
  }, [newsData]); // useEffect(() => {
  //   if (
  //     "metaTitle" in metaDetails ||
  //     "metaDescription" in metaDetails ||
  //     "metaKeywords" in metaDetails ||
  //     "metaTitleText" in metaDetails ||
  //     "metaDescriptionText" in metaDetails ||
  //     "metaKeywordsText" in metaDetails ||
  //     "metaTitleVideo" in metaDetails ||
  //     "metaDescriptionVideo" in metaDetails ||
  //     "metaKeywordsVideo" in metaDetails
  //   ) {
  //     setShowMetaFromApi(true);
  //   }
  // }, []);
  // const [showMetaTiteFromApi, setShowMetaTitleFromApi] = useState(false);
  // const [showMetaKeywordFromApi, setShowMetaKeywordFromApi] = useState(false);
  // const [showMetaDescriptionFromApi, setShowMetaDescriptionFromApi] =
  //   useState(false);

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (mainUrl === "") {
      console.log("Run111 1", metaDetails);

      if ("metaTitle" in metaDetails) {
        console.log("Run111 2", metaDetails["metaTitle"]);
        setShowMetaTitleFromApi(metaDetails["metaTitle"]);
      } else if (category && _constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category] && Object.keys(_constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category]).length > 0) {
        var _metaTags$path;

        setShowMetaTitleFromApi(_constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category] && ((_metaTags$path = _constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category === "latest" ? pageType : category][path[path.length - 1]]) === null || _metaTags$path === void 0 ? void 0 : _metaTags$path.metaTitle));
      } else {
        setShowMetaTitleFromApi("TheLallantop");
      }

      if ("metaDescription" in metaDetails) {
        setShowMetaDescriptionFromApi(metaDetails["metaDescription"]);
      } else if (category && _constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category] && Object.keys(_constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category]).length > 0) {
        var _metaTags$path2;

        setShowMetaDescriptionFromApi(_constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category] && ((_metaTags$path2 = _constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category === "latest" ? pageType : category][path[path.length - 1]]) === null || _metaTags$path2 === void 0 ? void 0 : _metaTags$path2.metaDescription));
      } else {
        setShowMetaDescriptionFromApi("TheLallantop provides Latest Hindi News on Politics, Business, Bollywood, Cricket, Education, Sports and more from India and around the world");
      }

      if ("metaKeywords" in metaDetails) {
        setShowMetaKeywordFromApi(metaDetails["metaKeywords"]);
      } else {
        var _metaTags$path3;

        setShowMetaKeywordFromApi("".concat(_constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category] && ((_metaTags$path3 = _constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category === "latest" ? pageType : category][path[path.length - 1]]) === null || _metaTags$path3 === void 0 ? void 0 : _metaTags$path3.metaKeyword)));
      }
    } else if (mainUrl === "text") {
      if ("metaTitleText" in metaDetails) {
        setShowMetaTitleFromApi(metaDetails["metaTitleText"]);
      } else if (category && _constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category] && Object.keys(_constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category]).length > 0) {
        var _metaTags$path4;

        setShowMetaTitleFromApi(_constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category] && ((_metaTags$path4 = _constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category === "latest" ? pageType : category][path[path.length - 1]]) === null || _metaTags$path4 === void 0 ? void 0 : _metaTags$path4.metaTitle));
      } else {
        setShowMetaTitleFromApi("TheLallantop");
      }

      if ("metaDescriptionText" in metaDetails) {
        setShowMetaDescriptionFromApi(metaDetails["metaDescriptionText"]);
      } else if (category && _constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category] && Object.keys(_constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category]).length > 0) {
        var _metaTags$path5;

        setShowMetaDescriptionFromApi(_constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category] && ((_metaTags$path5 = _constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category === "latest" ? pageType : category][path[path.length - 1]]) === null || _metaTags$path5 === void 0 ? void 0 : _metaTags$path5.metaDescription));
      } else {
        setShowMetaDescriptionFromApi("TheLallantop provides Latest Hindi News on Politics, Business, Bollywood, Cricket, Education, Sports and more from India and around the world");
      }

      if ("metaKeywordsText" in metaDetails) {
        setShowMetaKeywordFromApi(metaDetails["metaKeywordsText"]);
      } else {
        var _metaTags$path6;

        setShowMetaKeywordFromApi("".concat(_constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category] && ((_metaTags$path6 = _constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category === "latest" ? pageType : category][path[path.length - 1]]) === null || _metaTags$path6 === void 0 ? void 0 : _metaTags$path6.metaKeyword)));
      }
    } else {
      if ("metaTitleVideo" in metaDetails) {
        setShowMetaTitleFromApi(metaDetails["metaTitleVideo"]);
      } else if (category && _constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category] && Object.keys(_constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category]).length > 0) {
        var _metaTags$path7;

        setShowMetaTitleFromApi(_constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category] && ((_metaTags$path7 = _constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category === "latest" ? pageType : category][path[path.length - 1]]) === null || _metaTags$path7 === void 0 ? void 0 : _metaTags$path7.metaTitle));
      } else {
        setShowMetaTitleFromApi("TheLallantop");
      }

      if ("metaDescriptionVideo" in metaDetails) {
        setShowMetaDescriptionFromApi(metaDetails["metaDescriptionVideo"]);
      } else if (category && _constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category] && Object.keys(_constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category]).length > 0) {
        var _metaTags$path8;

        setShowMetaDescriptionFromApi(_constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category] && ((_metaTags$path8 = _constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category === "latest" ? pageType : category][path[path.length - 1]]) === null || _metaTags$path8 === void 0 ? void 0 : _metaTags$path8.metaDescription));
      } else {
        setShowMetaDescriptionFromApi("TheLallantop provides Latest Hindi News on Politics, Business, Bollywood, Cricket, Education, Sports and more from India and around the world");
      }

      if ("metaKeywordsVideo" in metaDetails) {
        setShowMetaKeywordFromApi(metaDetails["metaKeywordsVideo"]);
      } else {
        var _metaTags$path9;

        setShowMetaKeywordFromApi("".concat(_constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category] && ((_metaTags$path9 = _constants_metaTags__WEBPACK_IMPORTED_MODULE_17__/* .metaTags */ .V[category === "latest" ? pageType : category][path[path.length - 1]]) === null || _metaTags$path9 === void 0 ? void 0 : _metaTags$path9.metaKeyword)));
      }
    }
  }, []);
  var getMorePost1 = (0,debounce__WEBPACK_IMPORTED_MODULE_8__.debounce)( /*#__PURE__*/(0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
    var _newPosts$result2, res, newPosts, _newPosts$result4, _res, _newPosts, _newPosts2$result2, _res2, _newPosts2, _newPosts3$result2, _res3, _newPosts3;

    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(router !== null && router !== void 0 && router.pathname.includes("/[categoryName]/[subCategoryName]"))) {
              _context.next = 12;
              break;
            }

            _context.next = 3;
            return fetch("".concat(api_constants__WEBPACK_IMPORTED_MODULE_30__/* .baseUrl */ .FH, "/web/postListBySubCategory/").concat((query === null || query === void 0 ? void 0 : query.categorySlug) || (query === null || query === void 0 ? void 0 : query.categoryName), "/").concat((query === null || query === void 0 ? void 0 : query.subCategorySlug) || (query === null || query === void 0 ? void 0 : query.subCategoryName), "?limit=9&skip=").concat(isNaN(skipPerPage) ? "2" : skipPerPage, "&type=").concat(query.type == 'text' ? 'text,liveblog' : query.type == 'video' ? 'video' : pageToOpen), {
              headers: {
                accesstype: "web"
              }
            });

          case 3:
            res = _context.sent;
            _context.next = 6;
            return res.json();

          case 6:
            newPosts = _context.sent;
            setPosts(function (post) {
              var _newPosts$result;

              return [].concat((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(post), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(newPosts === null || newPosts === void 0 ? void 0 : (_newPosts$result = newPosts.result) === null || _newPosts$result === void 0 ? void 0 : _newPosts$result.entities));
            });
            setSkipPerPage(function (skip) {
              return skip + 1;
            });

            if (!(newPosts !== null && newPosts !== void 0 && (_newPosts$result2 = newPosts.result) !== null && _newPosts$result2 !== void 0 && _newPosts$result2.entities.length)) {
              setHasMore(false);
            }

            _context.next = 47;
            break;

          case 12:
            if (!(router !== null && router !== void 0 && router.pathname.includes("/[categoryName]"))) {
              _context.next = 25;
              break;
            }

            console.log(query.type, ' querytype');
            _context.next = 16;
            return fetch("".concat(api_constants__WEBPACK_IMPORTED_MODULE_30__/* .baseUrl */ .FH, "/web/postListByCategory/").concat((query === null || query === void 0 ? void 0 : query.categorySlug) || (query === null || query === void 0 ? void 0 : query.categoryName), "?limit=9&skip=").concat(isNaN(skipPerPage) ? "2" : skipPerPage, "&type=").concat(query.type == 'text' ? 'text,liveblog' : query.type == 'video' ? 'video' : pageToOpen), {
              headers: {
                accesstype: "web"
              }
            });

          case 16:
            _res = _context.sent;
            _context.next = 19;
            return _res.json();

          case 19:
            _newPosts = _context.sent;
            setPosts(function (post) {
              var _newPosts$result3;

              return [].concat((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(post), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(_newPosts === null || _newPosts === void 0 ? void 0 : (_newPosts$result3 = _newPosts.result) === null || _newPosts$result3 === void 0 ? void 0 : _newPosts$result3.entities));
            });
            setSkipPerPage(function (skip) {
              return skip + 1;
            });

            if (!(_newPosts !== null && _newPosts !== void 0 && (_newPosts$result4 = _newPosts.result) !== null && _newPosts$result4 !== void 0 && _newPosts$result4.entities.length)) {
              setHasMore(false);
            }

            _context.next = 47;
            break;

          case 25:
            if (!(router !== null && router !== void 0 && router.pathname.includes("/featured"))) {
              _context.next = 37;
              break;
            }

            _context.next = 28;
            return fetch("".concat(api_constants__WEBPACK_IMPORTED_MODULE_30__/* .baseUrl */ .FH, "/featured/rankFeatured?limit=9&skip=").concat(isNaN(skipPerPage) ? "2" : skipPerPage, "&type=").concat(query.type == 'text' ? 'text,liveblog' : query.type == 'video' ? 'video' : pageToOpen), {
              headers: {
                accesstype: "web"
              }
            });

          case 28:
            _res2 = _context.sent;
            _context.next = 31;
            return _res2.json();

          case 31:
            _newPosts2 = _context.sent;
            setPosts(function (post) {
              var _newPosts2$result;

              return [].concat((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(post), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(_newPosts2 === null || _newPosts2 === void 0 ? void 0 : (_newPosts2$result = _newPosts2.result) === null || _newPosts2$result === void 0 ? void 0 : _newPosts2$result.entities));
            });
            setSkipPerPage(function (skip) {
              return skip + 1;
            });

            if (!(_newPosts2 !== null && _newPosts2 !== void 0 && (_newPosts2$result2 = _newPosts2.result) !== null && _newPosts2$result2 !== void 0 && _newPosts2$result2.entities.length)) {
              setHasMore(false);
            }

            _context.next = 47;
            break;

          case 37:
            if (!(router !== null && router !== void 0 && router.pathname.includes("/latest"))) {
              _context.next = 47;
              break;
            }

            _context.next = 40;
            return fetch("".concat(api_constants__WEBPACK_IMPORTED_MODULE_30__/* .baseUrl */ .FH, "/web/trending?limit=9&skip=").concat(isNaN(skipPerPage) ? "2" : skipPerPage, "&type=").concat(query.type == 'text' ? 'text,liveblog' : query.type == 'video' ? 'video' : pageToOpen), {
              headers: {
                accesstype: "web"
              }
            });

          case 40:
            _res3 = _context.sent;
            _context.next = 43;
            return _res3.json();

          case 43:
            _newPosts3 = _context.sent;
            setPosts(function (post) {
              var _newPosts3$result;

              return [].concat((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(post), (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_31__/* ["default"] */ .Z)(_newPosts3 === null || _newPosts3 === void 0 ? void 0 : (_newPosts3$result = _newPosts3.result) === null || _newPosts3$result === void 0 ? void 0 : _newPosts3$result.entities));
            });
            setSkipPerPage(function (skip) {
              return skip + 1;
            });

            if (!(_newPosts3 !== null && _newPosts3 !== void 0 && (_newPosts3$result2 = _newPosts3.result) !== null && _newPosts3$result2 !== void 0 && _newPosts3$result2.entities.length)) {
              setHasMore(false);
            }

          case 47:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), 300);

  var _useState10 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""),
      subCategory = _useState10[0],
      setSubCategory = _useState10[1];

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""),
      subCategoryHindi = _useState11[0],
      setSubCategoryHindi = _useState11[1];

  var _useState12 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      currentCategory = _useState12[0],
      setCurrentCategory = _useState12[1];

  var _useState13 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""),
      categoryKeyword = _useState13[0],
      setCategoryKeyword = _useState13[1];

  var _useState14 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      adCalled = _useState14[0],
      setAdCalled = _useState14[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    function onFirstScroll() {
      return _onFirstScroll.apply(this, arguments);
    }

    function _onFirstScroll() {
      _onFirstScroll = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2() {
        return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!firstScroll) {
                  setFirstScroll(true);
                }

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _onFirstScroll.apply(this, arguments);
    }

    function handleScroll() {
      onFirstScroll();
      window.removeEventListener("scroll", handleScroll);
    }

    window.addEventListener("scroll", handleScroll);
  }, [currentCategory]);
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useDispatch */ .I0)();

  var _useSelector = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function (_ref3) {
    var CategoryReducer = _ref3.CategoryReducer;
    return CategoryReducer;
  }),
      subCategoryItem = _useSelector.subCategoryItem,
      category1 = _useSelector.category1;

  var categorizedNewsArray = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function () {
    var i,
        j,
        arrayChunk = [],
        chunk = 9; // console.log("categorizedNewsArrayPosts", posts);

    for (i = 0, j = posts === null || posts === void 0 ? void 0 : posts.length; i < j; i += chunk) {
      arrayChunk.push(posts === null || posts === void 0 ? void 0 : posts.slice(i, i + chunk));
    }

    return arrayChunk;
  }, [posts]);

  var _useState15 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""),
      language = _useState15[0],
      setLanguage = _useState15[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    setLanguage((0,localization_i8intl__WEBPACK_IMPORTED_MODULE_13__/* .getLanguage */ .G3)());
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (query !== null && query !== void 0 && query.categoryName) {
      var filteredSubCategory = subCategoryItem && subCategoryItem.length > 0 && (subCategoryItem === null || subCategoryItem === void 0 ? void 0 : subCategoryItem.filter(function (subCatItem) {
        return (subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem.slug) === (query === null || query === void 0 ? void 0 : query.subCategoryName);
      })[0]);
      setSubCategory(language === "hi" ? filteredSubCategory === null || filteredSubCategory === void 0 ? void 0 : filteredSubCategory.nameHn : filteredSubCategory === null || filteredSubCategory === void 0 ? void 0 : filteredSubCategory.name);
      setSubCategoryHindi(filteredSubCategory === null || filteredSubCategory === void 0 ? void 0 : filteredSubCategory.name);
    }
  }, [query === null || query === void 0 ? void 0 : query.subCategoryName, subCategoryItem, language, query === null || query === void 0 ? void 0 : query.categoryName]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (query !== null && query !== void 0 && query.categoryName) {
      var _category1$categories;

      var filteredCategory = category1 === null || category1 === void 0 ? void 0 : (_category1$categories = category1.categories) === null || _category1$categories === void 0 ? void 0 : _category1$categories.filter(function (catItem) {
        return (catItem === null || catItem === void 0 ? void 0 : catItem.slug) === (query === null || query === void 0 ? void 0 : query.categoryName);
      })[0];
      setFirstScroll(false);
      setCurrentCategory(filteredCategory);
      setCategoryKeyword(language === "hi" ? filteredCategory === null || filteredCategory === void 0 ? void 0 : filteredCategory.nameHn : filteredCategory === null || filteredCategory === void 0 ? void 0 : filteredCategory.name);
    }
  }, [query === null || query === void 0 ? void 0 : query.categoryName, category1, language]);
  var formSubcategoryQuery = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function (_id) {
    var _router$query2 = router.query,
        subCategoryId = _router$query2.subCategoryId,
        restQuery = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)(_router$query2, _excluded);

    return _objectSpread(_objectSpread({}, restQuery), {}, {
      subCategoryId: subCategoryId ? _id : _id
    });
  }, [router.query]);

  var _useSelector2 = (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .useSelector */ .v9)(function (_ref4) {
    var AdsReducer = _ref4.AdsReducer;
    return AdsReducer;
  }),
      adPlacement300_250 = _useSelector2.adPlacement300_250,
      adPlacement970_250 = _useSelector2.adPlacement970_250;

  swiper__WEBPACK_IMPORTED_MODULE_11__/* ["default"].use */ .ZP.use([swiper__WEBPACK_IMPORTED_MODULE_11__/* .Navigation */ .W_]);
  var navprevRef = react__WEBPACK_IMPORTED_MODULE_2__.useRef(null);
  var navnextRef = react__WEBPACK_IMPORTED_MODULE_2__.useRef(null);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    dispatch((0,redux_actions_ads_Actions__WEBPACK_IMPORTED_MODULE_33__/* .getAdsBySize */ .R)());
  }, [dispatch]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    var _posts$;

    dispatch((0,redux_actions_categoryActions__WEBPACK_IMPORTED_MODULE_34__/* .subCategoriesItems */ .Pj)({
      _id: (_posts$ = posts[0]) === null || _posts$ === void 0 ? void 0 : _posts$.categoryId
    }));
  }, [dispatch, posts]);
  var smallElection = [1, 2, 3, 4, 5]; // useEffect(() => {
  //   if (window && window._taboola !== undefined) {
  //     window._taboola = window._taboola || [];
  //     _taboola.push({
  //       mode: "alternating-thumbnails-a",
  //       container: "taboola-below-category-thumbnails",
  //       placement: "Below Category Thumbnails",
  //       target_type: "mix",
  //     });
  //   }
  // }, []);

  var category = router.pathname.includes("latest") ? "latest" : router.pathname.includes("text") ? "text" : router.pathname.includes("video") ? "video" : (_router$query3 = router.query) === null || _router$query3 === void 0 ? void 0 : _router$query3.categoryName;
  var pageType = "";

  if (router.pathname.includes("latest")) {
    pageType = router.pathname.includes("text") ? "text" : router.pathname.includes("video") ? "video" : "latest";
  }

  var path = router.asPath.split("/");
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    var showAds = true;

    if (false) {}

    if (showAds && !adCalled) {
      setAdCalled(true);
      setTimeout(function () {
        window.googletag = window.googletag || {
          cmd: []
        };

        if (window.screen.width > 600) {
          googletag.cmd.push(function () {
            googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_ATF_728x90", [[728, 90], [970, 250], [970, 90]], "div-gpt-ad-1701945163318-0").addService(googletag.pubads());
            googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_MTF_1_728x90", [728, 90], "div-gpt-ad-1701945220410-1").addService(googletag.pubads());
            {
              subCategoryName !== "haryana-assembly-chunav" && googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_MTF_2_728x90", [728, 90], "div-gpt-ad-1701945220410-2").addService(googletag.pubads());
            } //  googletag.defineOutOfPageSlot('/1007232/Lallantop_Mobile_HP_Mweb_Interstitial',googletag.enums.OutOfPageFormat.INTERSTITIAL).addService(googletag.pubads());

            googletag.pubads().enableSingleRequest();
            googletag.pubads().setTargeting("Category", ["".concat(categoryName)]);
            googletag.pubads().setTargeting("Keywords", metaDetails === null || metaDetails === void 0 ? void 0 : metaDetails.metaKeywords);
            googletag.pubads().enableSingleRequest();
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            (0,_Ads_index__WEBPACK_IMPORTED_MODULE_25__/* .requestBiddingFromPWT */ .WX)();
          });
        } else {
          googletag.cmd.push(function () {
            googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_ATF_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-0").addService(googletag.pubads());
            googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_MTF_1_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-1").addService(googletag.pubads());
            {
              subCategoryName !== "haryana-assembly-chunav" && googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_MTF_2_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-2").addService(googletag.pubads());
            }
            googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_Bottom_320x50", [320, 50], "div-gpt-ad-1701946324333-0").addService(googletag.pubads());
            googletag.defineOutOfPageSlot("/1007232/Lallantop_Mobile_ROS_Mweb_Interstitial", googletag.enums.OutOfPageFormat.INTERSTITIAL).addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            (0,_Ads_index__WEBPACK_IMPORTED_MODULE_25__/* .requestBiddingFromPWT */ .WX)();
          });
        } // apstag.fetchBids(
        //   {
        //     slots:
        //       size?.width < 499
        //         ? createApsSlotsRosMobile({})
        //         : createApsSlotsRosDesktop({}),
        //     timeout: 2e3,
        //   },
        //   apstagBidCallback
        // );

      }, 500);
    }
  }, [firstScroll]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (size.width) {
      apstag.fetchBids({
        slots: size.width < 768 ? (0,_Ads_index__WEBPACK_IMPORTED_MODULE_25__/* .createApsSlotsRosMobile */ .PI)({}) : (0,_Ads_index__WEBPACK_IMPORTED_MODULE_25__/* .createApsSlotsRosDesktop */ .VG)({}),
        timeout: 2e3
      }, _Ads_index__WEBPACK_IMPORTED_MODULE_25__/* .apstagBidCallback */ .O8);
    }
  }, [size.width]);

  if (true) {
    var _document$getElements;

    var swiper = document.getElementsByClassName("swiper-button-lock")[0];
    var element = (_document$getElements = document.getElementsByClassName("swiper")[0]) === null || _document$getElements === void 0 ? void 0 : _document$getElements.style;

    if (swiper) {
      if (element) element.paddingRight = 0;
    } else {
      if (element) element.paddingRight = "7rem";
    }
  } // const getElectionTopic = async () => {
  //   const res = await fetch(
  //     `${baseUrl}/topicItem/getContentsBySlugAndType?limit=6&skip=1&slug=chunav-yatra-2024&type=video`,
  //     {
  //       method: "GET",
  //       headers: {
  //         "content-type": "application/json",
  //       },
  //     }
  //   );
  //   const newPosts = await res.json();
  //   if (newPosts?.result?.entities?.length > 0) {
  //     console.log("Topic data for elction ", newPosts?.result?.entities);
  //     setElectionTopicData(newPosts?.result?.entities);
  //   } else {
  //     // setHasMore({ ...hasMore, [activeTab]: false });
  //   }
  //   // setSkipPerPage({ ...skipPerPage, [activeTab]: skipPerPage["text"] + 10 });
  //   // } else setLoginPrompt(true);
  // };
  // useEffect(() => {
  //   console.log("Current Category 2", router.query.categoryName);
  //   if (router.query.categoryName === "election") {
  //     getElectionTopic();
  //   }
  // }, []);


  var oddnaariMobile = function oddnaariMobile(newsData, indexVaue) {
    var _newsData$slice, _newsData$slice2, _newsData$slice3, _newsData$slice4, _newsData$slice5, _newsData$slice6;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.Fragment, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
        className: "outer-containers3",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
          className: "content-container3",
          style: {
            width: "100% !important"
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
            className: "content",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
              className: "left-area-Col",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                style: {},
                children: [newsData === null || newsData === void 0 ? void 0 : (_newsData$slice = newsData.slice(0, 1)) === null || _newsData$slice === void 0 ? void 0 : _newsData$slice.map(function (postData, index) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                    children: (postData === null || postData === void 0 ? void 0 : postData._id) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(NewsImageTextBanner1, {
                      postData: postData,
                      hTag: indexVaue == 0 ? 2 : 3
                    })
                  }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
                }), indexVaue === 0 && size.width < 600 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.Fragment, {
                  children: [(articlePageBanners === null || articlePageBanners === void 0 ? void 0 : articlePageBanners.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                    className: "checkMobileOrNot ",
                    style: {
                      marginTop: "6px"
                    },
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(DynamicBanner, {
                      list: articlePageBanners,
                      type: "msite",
                      page: "category"
                    })
                  }), (masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.MoveAdsUp) != true && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
                    align: "center",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                      className: "container-row py-2",
                      align: "center",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("p", {
                        style: {
                          fontSize: "11px",
                          color: "#b7b7b7",
                          textAlign: "center",
                          marginBottom: "0px"
                        },
                        children: "Advertisement"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                        id: "div-gpt-ad-1701946028239-0",
                        style: {
                          minWidth: "300px",
                          minHeight: "260px",
                          display: "block !important",
                          alignContent: "center",
                          textAlign: "-webkit-center"
                        },
                        className: "ads-auto-resize",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("script", {
                          type: "text/javascript",
                          dangerouslySetInnerHTML: {
                            __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})"
                          }
                        })
                      })]
                    })
                  })]
                })]
              }), newsData === null || newsData === void 0 ? void 0 : (_newsData$slice2 = newsData.slice(1, 3)) === null || _newsData$slice2 === void 0 ? void 0 : _newsData$slice2.map(function (postData, index) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(components_newsCard_readNews__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    postData: postData,
                    isBanner: false
                  }, "index_".concat(index, "_").concat(postData === null || postData === void 0 ? void 0 : postData._id))
                }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
              className: "left-area-Col",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                style: {},
                children: newsData === null || newsData === void 0 ? void 0 : (_newsData$slice3 = newsData.slice(3, 4)) === null || _newsData$slice3 === void 0 ? void 0 : _newsData$slice3.map(function (postData, index) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                    children: (postData === null || postData === void 0 ? void 0 : postData._id) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(NewsImageTextBanner1, {
                      postData: postData,
                      hTag: indexVaue == 0 ? 2 : 3
                    })
                  }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
                })
              }), newsData === null || newsData === void 0 ? void 0 : (_newsData$slice4 = newsData.slice(4, 6)) === null || _newsData$slice4 === void 0 ? void 0 : _newsData$slice4.map(function (postData, index) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(components_newsCard_readNews__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    postData: postData,
                    isBanner: false
                  }, "index_".concat(index, "_").concat(postData === null || postData === void 0 ? void 0 : postData._id))
                }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
              className: "right-area-Col",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                style: {},
                children: newsData === null || newsData === void 0 ? void 0 : (_newsData$slice5 = newsData.slice(6, 7)) === null || _newsData$slice5 === void 0 ? void 0 : _newsData$slice5.map(function (postData, index) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                    children: (postData === null || postData === void 0 ? void 0 : postData._id) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(NewsImageTextBanner1, {
                      postData: postData,
                      hTag: indexVaue == 0 ? 2 : 3
                    })
                  }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
                })
              }), newsData === null || newsData === void 0 ? void 0 : (_newsData$slice6 = newsData.slice(7, 9)) === null || _newsData$slice6 === void 0 ? void 0 : _newsData$slice6.map(function (postData, index) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(components_newsCard_readNews__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    postData: postData,
                    isBanner: false
                  }, "index_".concat(index, "_").concat(postData === null || postData === void 0 ? void 0 : postData._id))
                }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
              })]
            })]
          })
        })
      })
    });
  };

  var oddnaariDesktop = function oddnaariDesktop(newsData, indexVaue) {
    var _columnA$slice, _columnA$slice2, _columnB$slice, _columnB$slice2, _columnC$slice, _columnC$slice2;

    var columnA = [];
    var columnB = [];
    var columnC = [];
    columnA.push(newsData[0], newsData[3], newsData[6]);
    columnB.push(newsData[1], newsData[4], newsData[7]);
    columnC.push(newsData[2], newsData[5], newsData[8]);
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.Fragment, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
        className: "outer-containers3",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
          className: "content-container3",
          style: {
            width: "100% !important"
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
            className: "content",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
              className: "left-area-Col",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                style: {},
                children: columnA === null || columnA === void 0 ? void 0 : (_columnA$slice = columnA.slice(0, 1)) === null || _columnA$slice === void 0 ? void 0 : _columnA$slice.map(function (postData, index) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                    children: (postData === null || postData === void 0 ? void 0 : postData._id) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(NewsImageTextBanner1, {
                      postData: postData,
                      hTag: indexVaue == 0 ? 2 : 3
                    })
                  }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
                })
              }), columnA === null || columnA === void 0 ? void 0 : (_columnA$slice2 = columnA.slice(1, 3)) === null || _columnA$slice2 === void 0 ? void 0 : _columnA$slice2.map(function (postData, index) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(components_newsCard_readNews__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    postData: postData,
                    isBanner: false
                  }, "index_".concat(index, "_").concat(postData === null || postData === void 0 ? void 0 : postData._id))
                }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
              className: "left-area-Col",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                style: {},
                children: columnB === null || columnB === void 0 ? void 0 : (_columnB$slice = columnB.slice(0, 1)) === null || _columnB$slice === void 0 ? void 0 : _columnB$slice.map(function (postData, index) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                    children: (postData === null || postData === void 0 ? void 0 : postData._id) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(NewsImageTextBanner1, {
                      postData: postData,
                      hTag: indexVaue == 0 ? 2 : 3
                    })
                  }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
                })
              }), columnB === null || columnB === void 0 ? void 0 : (_columnB$slice2 = columnB.slice(1, 3)) === null || _columnB$slice2 === void 0 ? void 0 : _columnB$slice2.map(function (postData, index) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(components_newsCard_readNews__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    postData: postData,
                    isBanner: false
                  }, "index_".concat(index, "_").concat(postData === null || postData === void 0 ? void 0 : postData._id))
                }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
              className: "right-area-Col",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                style: {},
                children: columnC === null || columnC === void 0 ? void 0 : (_columnC$slice = columnC.slice(0, 1)) === null || _columnC$slice === void 0 ? void 0 : _columnC$slice.map(function (postData, index) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                    children: (postData === null || postData === void 0 ? void 0 : postData._id) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(NewsImageTextBanner1, {
                      postData: postData,
                      hTag: indexVaue == 0 ? 2 : 3
                    })
                  }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
                })
              }), columnC === null || columnC === void 0 ? void 0 : (_columnC$slice2 = columnC.slice(1, 3)) === null || _columnC$slice2 === void 0 ? void 0 : _columnC$slice2.map(function (postData, index) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_35__/* ["default"] */ .Z, {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(components_newsCard_readNews__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    postData: postData,
                    isBanner: false
                  }, "index_".concat(index, "_").concat(postData === null || postData === void 0 ? void 0 : postData._id))
                }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
              })]
            })]
          })
        })
      })
    });
  };

  var sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);

  var updateScrollButtons = function updateScrollButtons() {
    var slider = sliderRef.current;

    if (slider) {
      // setCanScrollLeft(slider.scrollLeft > 0);
      if (!canScrollRight && slider.scrollLeft + slider.clientWidth < slider.scrollWidth) {
        setCanScrollRight(true);
      }
    }
  };

  var scrollLeft = function scrollLeft() {
    sliderRef.current.scrollTo({
      left: sliderRef.current.scrollLeft + 150,
      // Adjust the value for how far to scroll left
      behavior: "smooth" // Enable smooth scrolling

    });
  };

  var scrollRight = function scrollRight() {
    sliderRef.current.scrollTo({
      left: sliderRef.current.scrollLeft - 150,
      // Adjust the value for how far to scroll left
      behavior: "smooth" // Enable smooth scrolling

    });
  };

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    var slider = sliderRef.current;

    if (slider && !canScrollRight) {
      updateScrollButtons(); // Check on mount
      // Attach event listeners

      slider.addEventListener("scroll", updateScrollButtons);
      window.addEventListener("resize", updateScrollButtons); // Cleanup

      return function () {
        slider.removeEventListener("scroll", updateScrollButtons);
        window.removeEventListener("resize", updateScrollButtons);
      };
    }
  }, [sliderRef === null || sliderRef === void 0 ? void 0 : sliderRef.current]);

  var subCatsHref = function subCatsHref(subCatItem) {
    // Fetch query params from the current URL
    var params = new URLSearchParams(window.location.search);
    var newStr = null;

    if (params.toString()) {
      var url = "".concat("".concat(mainUrl === "" ? "" : "/" + mainUrl + "/", "/").concat(query === null || query === void 0 ? void 0 : query.categoryName, "/").concat(subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem.slug), "?", params.toString());
      newStr = url.replace("//", "/");
    } else {
      var _url = "".concat("".concat(mainUrl === "" ? "" : "/" + mainUrl + "/", "/").concat(query === null || query === void 0 ? void 0 : query.categoryName, "/").concat(subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem.slug));

      newStr = _url.replace("//", "/");
    }

    return newStr;
  };

  var breadcrumbSchemaUrlLevel2 = function breadcrumbSchemaUrlLevel2() {
    var _router$query4;

    var url = "".concat(mainUrl, "/").concat(router.pathname.includes("latest") ? "latest" : (_router$query4 = router.query) === null || _router$query4 === void 0 ? void 0 : _router$query4.categoryName);
    var newStr = url.replace("//", "/");
    console.log("newStr", "https://www.thelallantop.com/" + "" + newStr.substring(1));
    return "https://www.thelallantop.com/" + "" + newStr.substring(1);
  }; // useEffect(() => {
  //   if (router.asPath.includes("/sports")) {
  //     const script = document.createElement("script");
  //     script.innerHTML = `
  //     window._izq = window._izq || [];
  //     window._izq.push(["userProfile", {
  //       "add": {
  //         "Category": "Sports"
  //       }
  //     }]);
  //   `;
  //     script.defer = true;
  //     document.head.appendChild(script);
  //   }
  //   return () => {
  //     document.head.removeChild(script); // Cleanup when component unmounts
  //   };
  // }, []);


  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_15___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("meta", {
        property: "fb:pages",
        content: "1453842511589254"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("script", {
        id: "my-script-detail",
        type: "application/ld+json",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "http://schema.org/",
            "@type": "WebPage",
            name: "".concat(showMetaTitleFromApi),
            description: "".concat(showMetaDescriptionFromApi),
            keywords: "".concat(showMetaKeywordFromApi),
            url: "https://www.thelallantop.com/".concat(categoryName),
            publisher: {
              "@type": "Organization",
              name: "The Lallantop",
              url: "https://www.thelallantop.com/",
              logo: {
                "@type": "ImageObject",
                url: "https://www.thelallantop.com/assets/images/lallatop-logo-m.svg",
                width: 600,
                height: 60
              }
            }
          })
        }
      }), categoryName === "election" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("script", {
        id: "my-script-detail",
        type: "application/ld+json",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SiteNavigationElement",
            name: ["होम", "चुनाव", "न्यूज़", "एंटरटेनमेंट", "ऑडनारी", "टेक्नोलॉजी", "पड़ताल", "बिज़नेस", "लल्लनख़ास", "स्पोर्ट्स", "रंगरूट"],
            url: ["https://www.thelallantop.com/", "https://www.thelallantop.com/election", "https://www.thelallantop.com/news", "https://www.thelallantop.com/entertainment", "https://www.thelallantop.com/oddnaari", "https://www.thelallantop.com/technology", "https://www.thelallantop.com/factcheck", "https://www.thelallantop.com/business", "https://www.thelallantop.com/lallankhas", "https://www.thelallantop.com/sports", "https://www.thelallantop.com/education"]
          })
        }
      }), typeof subCategoryName === undefined ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("script", {
        id: "my-script-detail",
        type: "application/ld+json",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [{
              "@type": "ListItem",
              position: 1,
              item: {
                // "@url": `${process.env.NEXT_PUBLIC_AUTH_URL}`,
                "@id": "".concat("https://www.thelallantop.com/"),
                name: "Lallantop Hindi News"
              }
            }, {
              "@type": "ListItem",
              position: 2,
              item: {
                name: "".concat(router.pathname.includes("latest") ? "लेटेस्ट" : (_newsData$ = newsData[0]) === null || _newsData$ === void 0 ? void 0 : _newsData$.categoryName),
                "@id": "".concat(breadcrumbSchemaUrlLevel2())
              }
            }]
          })
        }
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("script", {
        id: "my-script-detail",
        type: "application/ld+json",
        strategy: "afterInteractive",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [{
              "@type": "ListItem",
              position: 1,
              item: {
                // "@url": `${process.env.NEXT_PUBLIC_AUTH_URL}`,
                "@id": "".concat("https://www.thelallantop.com/"),
                name: "Lallantop Hindi News"
              }
            }, {
              "@type": "ListItem",
              position: 2,
              item: {
                // name: `${
                //   router.pathname.includes("latest")
                //     ? "लेटेस्ट"
                //     : newsData[0]?.categoryName
                // }`,
                name: "".concat(router.pathname.includes("latest") ? "Latest" : (_newsData$2 = newsData[0]) === null || _newsData$2 === void 0 ? void 0 : _newsData$2.categoryName),
                "@id": "".concat(breadcrumbSchemaUrlLevel2())
              }
            }]
          })
        }
      }), console.log("newsData[0]?.permaLink", newsData[0]), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("link", {
        rel: "amphtml",
        href: categoryName && subCategoryName ? "".concat("https://www.thelallantop.com", "/amp/").concat(category, "/").concat(subCategoryName) : "".concat("https://www.thelallantop.com", "/amp/").concat(category)
      })]
    }), console.log("subCategoryItem?.length", subCategoryItem === null || subCategoryItem === void 0 ? void 0 : subCategoryItem.length), (subCategoryItem === null || subCategoryItem === void 0 ? void 0 : subCategoryItem.length) > 6 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("style", {
      children: " .swiper-wrapper{\n            // justify-content: normal !important;\n          }"
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("style", {
      children: " .swiper-wrapper{\n            // justify-content: flex-end !important;\n          }"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("meta", {
      name: "keywords",
      content: showMetaKeywordFromApi
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_16__/* .NextSeo */ .PB, {
      title: showMetaTitleFromApi,
      description: showMetaDescriptionFromApi,
      canonical: "".concat("https://www.thelallantop.com").concat(router === null || router === void 0 ? void 0 : router.asPath)
    }), router.asPath === "/election/lok-sabha-chunav-2024" && size.width < 1100 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.Fragment, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
          style: {
            display: "flex",
            justifyContent: "center",
            paddingTop: "1rem",
            gap: "8px",
            cursor: "pointer",
            paddingBottom: "1rem",
            backgroundColor: "rgb(217, 54, 139)",
            marginTop: "10px"
          },
          onClick: function onClick() {
            return window.open("/election/lok-sabha-chunav-2024", "_self");
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("img", {
            src: "/assets/images/chunav-name.png",
            width: "197.58px",
            height: "45.21px",
            style: {
              alignSelf: "center"
            }
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
          "class": "divCategoriesSchedule snipcss-eqdpv",
          style: {
            margin: "-1px 0px",
            backgroundColor: "rgb(217, 54, 139)",
            paddingLeft: "15px",
            paddingBottom: "1rem"
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
            href: "/election/lok-sabha-chunav-2024/results",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
              children: "\u0915\u094C\u0928 \u091C\u0940\u0924\u093E-\u0915\u094C\u0928 \u0939\u093E\u0930\u093E"
            })
          }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
            href: "/election/lok-sabha-chunav-2024/key-candidates",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
              children: "\u092A\u094D\u0930\u092E\u0941\u0916 \u0909\u092E\u094D\u092E\u0940\u0926\u0935\u093E\u0930"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
            href: "/election/lok-sabha-chunav-2024/party-wise-result",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
              children: "\u0932\u094B\u0915 \u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
            href: "/election/vidhan-sabha-chunav-2024/party-wise-result",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
              children: "\u0935\u093F\u0927\u093E\u0928 \u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
            href: "/election/lok-sabha-chunav-2024/schedules",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
              children: "\u0936\u0947\u0921\u094D\u092F\u0942\u0932"
            })
          }), " "]
        })]
      })
    }), size.width < 600 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
      style: {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        width: "100%"
      },
      children: router.asPath.includes("election") && !router.asPath.includes("lok-sabha") && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
        style: {
          position: "relative",
          width: "100%"
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("img", {
          src: ((_electionStuff$ = electionStuff[0]) === null || _electionStuff$ === void 0 ? void 0 : _electionStuff$.creativeBanner) || "/assets/images/election-background-mobile.png",
          style: {
            position: "relative",
            width: "100%",
            height: "auto"
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("img", {
          src: "/assets/images/election-left-mobile.png",
          width: "",
          height: "70px",
          style: {
            position: "absolute",
            bottom: "10px",
            left: "10px"
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("img", {
          src: router.asPath.includes("haryana-assembly") ? "/assets/images/right-election-top-2.png" : router.asPath.includes("jammu-kashmir-assembly") ? "/assets/images/jammu-kashmir.png" : "/assets/images/indian-map.png",
          width: "",
          height: "90px",
          style: {
            position: "absolute",
            bottom: "0",
            right: "0px"
          }
        })]
      })
    }), size.width < 1100 && fromRoot && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.Fragment, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
          style: {
            display: "flex",
            justifyContent: "center",
            paddingTop: "1rem",
            gap: "8px",
            // cursor: "pointer",
            paddingBottom: "1rem",
            backgroundColor: "white",
            marginTop: "10px"
          } // onClick={() =>
          //   window.open("/election/lok-sabha-chunav-2024", "_self")
          // }
          ,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("img", {
            src: "/assets/images/assembly-chunav.png",
            width: "240px",
            height: "auto",
            style: {
              alignSelf: "center"
            }
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
          "class": "divCategoriesSchedule2 snipcss-eqdpv",
          style: {
            margin: "-1px 0px",
            backgroundColor: "white",
            paddingLeft: "15px",
            paddingBottom: "1rem",
            justifyContent: router.asPath.includes("jharkhand-") || router.asPath.includes("maharashtra-") ? "center" : "space-around"
          },
          children: (breadCrump === null || breadCrump === void 0 ? void 0 : breadCrump.length) > 0 ? breadCrump.map(function (item, index) {
            return masterConfig[item.keyToShow] != false ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
              href: item.url,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
                children: item.displayText
              })
            }, index) : null;
          }) : STATIC_BREADCRUMP.map(function (item, index) {
            return masterConfig[item.keyToShow] != false ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
              href: item.url,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
                children: item.displayText
              })
            }, index) : null;
          })
        })]
      })
    }),  false && /*#__PURE__*/0, size.width >= 600 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
      style: {
        position: "relative",
        display: "flex",
        justifyContent: "center"
      },
      children: [router.asPath.includes("election") && !router.asPath.includes("lok-sabha") && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
        style: {
          position: "relative"
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("img", {
          src: ((_electionStuff$2 = electionStuff[0]) === null || _electionStuff$2 === void 0 ? void 0 : _electionStuff$2.creativeBanner) || "/assets/images/election-background-3.png",
          style: {
            position: "relative",
            width: "100%",
            height: "298px"
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("img", {
          src: "/assets/images/left-election-top-2.png",
          width: "",
          height: "170px",
          style: {
            position: "absolute",
            bottom: "10px",
            left: "10px"
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("img", {
          src: router.asPath.includes("haryana-assembly") ? "/assets/images/right-election-top-2.png" : router.asPath.includes("jammu-kashmir-assembly") ? "/assets/images/jammu-kashmir.png" : "/assets/images/indian-map.png",
          width: "",
          height: "250px",
          style: {
            position: "absolute",
            bottom: "0",
            right: "0px"
          }
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
        align: "center",
        style: {
          position: router.asPath.includes("/election") && !router.asPath.includes("lok-sabha") ? "absolute" : "relative",
          top: router.asPath.includes("/election") ? "22px" : "0px"
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
          className: "container-row py-2",
          align: "center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("p", {
            style: {
              fontSize: "11px",
              color: "#b7b7b7",
              textAlign: "center",
              marginBottom: "0px"
            },
            children: "Advertisement"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
            id: "div-gpt-ad-1701945163318-0",
            style: {
              minWidth: "300px",
              minHeight: "100px",
              display: "block !important",
              alignContent: "center",
              textAlign: "-webkit-center"
            },
            className: "ads-auto-resize",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("script", {
              type: "text/javascript",
              dangerouslySetInnerHTML: {
                __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945163318-0')})"
              }
            })
          })]
        })
      })]
    }), router.asPath === "/election/lok-sabha-chunav-2024" && size.width >= 1100 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.Fragment, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
        style: {
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#D9368B",
          width: "85%",
          margin: "auto",
          gap: "68px",
          height: "80px",
          marginTop: "15px"
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
          style: {
            display: "flex",
            justifyContent: "center",
            // paddingTop: "1rem",
            gap: "8px",
            cursor: "pointer",
            backgroundColor: "rgb(217, 54, 139)",
            paddingLeft: "20px"
          },
          onClick: function onClick() {
            return window.open("/election/lok-sabha-chunav-2024", "_self");
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("img", {
            src: "/assets/images/chunav-name.png",
            width: "197.56px",
            height: "45.21px",
            style: {
              alignSelf: "center"
            }
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
          "class": "divCategoriesSchedule snipcss-eqdpv",
          style: {
            margin: "0px 0px",
            backgroundColor: "rgb(217, 54, 139)",
            paddingLeft: "15px",
            alignContent: "center"
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
            href: "/election/lok-sabha-chunav-2024/results",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
              children: "\u0915\u094C\u0928 \u091C\u0940\u0924\u093E-\u0915\u094C\u0928 \u0939\u093E\u0930\u093E"
            })
          }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
            href: "/election/lok-sabha-chunav-2024/key-candidates",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
              children: "\u092A\u094D\u0930\u092E\u0941\u0916 \u0909\u092E\u094D\u092E\u0940\u0926\u0935\u093E\u0930"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
            href: "/election/lok-sabha-chunav-2024/party-wise-result",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
              children: "\u0932\u094B\u0915 \u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
            href: "/election/vidhan-sabha-chunav-2024/party-wise-result",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
              children: "\u0935\u093F\u0927\u093E\u0928 \u0938\u092D\u093E \u0930\u093F\u091C\u0932\u094D\u091F"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
            href: "/election/lok-sabha-chunav-2024/exit-poll",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
              children: "\u090F\u0917\u094D\u091C\u093F\u091F \u092A\u094B\u0932"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
            href: "/election/lok-sabha-chunav-2024/schedules",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
              children: "\u0936\u0947\u0921\u094D\u092F\u0942\u0932"
            })
          }), " "]
        })]
      })
    }), // (
    //   router.asPath.includes("-assembly")) &&
    size.width >= 1100 && fromRoot && !router.asPath.includes("lok-sabha-chunav-2024") && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.Fragment, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
        style: {
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          width: "max-content",
          margin: "auto",
          gap: "68px",
          height: "80px",
          marginTop: "15px",
          borderRadius: "12px",
          padding: "0px 30px"
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
          style: {
            display: "flex",
            justifyContent: "center",
            // paddingTop: "1rem",
            gap: "8px",
            // cursor: "pointer",
            backgroundColor: "white",
            paddingLeft: "0px"
          } // onClick={() =>
          //   window.open("/election/lok-sabha-chunav-2024", "_self")
          // }
          ,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("img", {
            src: "/assets/images/assembly-chunav.png",
            width: "408.56px",
            height: "58.21px",
            style: {
              alignSelf: "center"
            }
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
          "class": "divCategoriesSchedule2 snipcss-eqdpv",
          style: {
            margin: "0px 0px",
            // backgroundColor: "rgb(217, 54, 139)",
            paddingLeft: "15px",
            alignContent: "center"
          },
          children: (breadCrump === null || breadCrump === void 0 ? void 0 : breadCrump.length) > 0 ? breadCrump.map(function (item, index) {
            return masterConfig[item.keyToShow] != false ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
              href: item.url,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
                children: item.displayText
              })
            }, index) : null;
          }) : STATIC_BREADCRUMP.map(function (item, index) {
            return masterConfig[item.keyToShow] != false ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
              href: item.url,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
                children: item.displayText
              })
            }, index) : null;
          })
        })]
      })
    }),  false && /*#__PURE__*/0, category == "election" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(components_elections_2023_ElectionsWidget__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("br", {}), category === "sports" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.Fragment, {
      children: [(masterConfig === null || masterConfig === void 0 ? void 0 : masterConfig.MoveAdsUp) == true && size.width < 768 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
        align: "center",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
          className: "container-row py-2",
          align: "center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("p", {
            style: {
              fontSize: "11px",
              color: "#b7b7b7",
              textAlign: "center",
              marginBottom: "0px"
            },
            children: "Advertisement"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
            id: "div-gpt-ad-1701946028239-0",
            style: {
              minWidth: "300px",
              minHeight: "260px",
              display: "block !important",
              alignContent: "center",
              textAlign: "-webkit-center"
            },
            className: "ads-auto-resize",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("script", {
              type: "text/javascript",
              dangerouslySetInnerHTML: {
                __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})"
              }
            })
          })]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(components_tally_Tally__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
        stateName: subCategoryName && ((_stateData$subCategor = constants_state__WEBPACK_IMPORTED_MODULE_24__/* .stateData */ .i[subCategoryName]) === null || _stateData$subCategor === void 0 ? void 0 : _stateData$subCategor.tallyState),
        masterConfig: masterConfig
      })]
    }), categoryName == 'sports' && masterConfigCT['ChampionsTrophyWidget']['ShowWidgetOnAllSport'] && newsData && scoreData && pointsData && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(components_cricket_WidgetHome__WEBPACK_IMPORTED_MODULE_27__["default"], {
        newsData: electionTopicData,
        scoreData: scoreData,
        pointsData: pointsData,
        table: pointsData.standings.stage1.groups[0],
        size: size
      })
    }), subCategoryName == 'cricket' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(components_cricket_Strip__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {
      showActive: 'all',
      size: size,
      list: STATIC_BREADCRUMP
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("br", {}), (posts === null || posts === void 0 ? void 0 : posts.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
      dataLength: posts === null || posts === void 0 ? void 0 : posts.length,
      next: getMorePost1,
      hasMore: hasMore,
      loader: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
        className: "lds-dual-ring"
      }),
      scrollThreshold: 0.4,
      children: categorizedNewsArray === null || categorizedNewsArray === void 0 ? void 0 : categorizedNewsArray.map(function (categorizedNews, index) {
        var _router$query5, _router$query6, _router$query7, _router$query8, _newsData$3, _newsData$4, _router$query9, _electionStuff$3, _electionStuff$4, _electionTopicData$, _electionTopicData$2, _electionTopicData$3, _electionTopicData$4, _electionTopicData$5, _electionTopicData$6, _Object$keys, _adPlacement970_250$i, _adPlacement970_250$i2;

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
          className: "content-wrapper",
          id: index,
          children: !!(newsData !== null && newsData !== void 0 && newsData.length) ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
              className: "container-row",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                className: "header-category-page",
                children: [index === 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.Fragment, {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("ul", {
                    className: "breadcrumb assembly-breadcrumb",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("li", {
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
                        href: "/",
                        passHref: true,
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("a", {
                          "aria-label": "Lallantop Home",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("i", {
                            className: "icon-cat-home"
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
                            children: "Home"
                          })]
                        })
                      })
                    }), router.pathname.includes("latest") && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("li", {
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
                        children: "Latest "
                      })
                    }), ((_router$query5 = router.query) === null || _router$query5 === void 0 ? void 0 : _router$query5.categoryName) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("li", {
                      children: (_router$query6 = router.query) !== null && _router$query6 !== void 0 && _router$query6.subCategoryName ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
                        href: "/".concat(mainUrl === "" ? "" : mainUrl + "/").concat((_router$query7 = router.query) === null || _router$query7 === void 0 ? void 0 : _router$query7.categoryName),
                        passHref: true,
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
                          "aria-label": "".concat((_router$query8 = router.query) === null || _router$query8 === void 0 ? void 0 : _router$query8.categoryName, " Category Name"),
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
                            children: (_newsData$3 = newsData[0]) === null || _newsData$3 === void 0 ? void 0 : _newsData$3.categoryName
                          })
                        })
                      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("span", {
                        children: [" ", (_newsData$4 = newsData[0]) === null || _newsData$4 === void 0 ? void 0 : _newsData$4.categoryName]
                      })
                    }), (query === null || query === void 0 ? void 0 : query.categoryName) && (query === null || query === void 0 ? void 0 : query.subCategoryName) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("li", {
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("span", {
                        children: [" ", subCategoryHindi]
                      })
                    })]
                  })
                }), index === 0 && ((_router$query9 = router.query) === null || _router$query9 === void 0 ? void 0 : _router$query9.categoryName) === "factcheck" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("ul", {
                  className: "breadcrumb",
                  style: {
                    width: "".concat(language === "hi" ? "500px" : "700px")
                  },
                  children: padtaalStaticHeadings.map(function (item, index) {
                    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("li", {
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
                        href: "".concat("/".concat(padtaalStaticHeadingsUrl[index])),
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
                          "aria-label": "Lallantop Home",
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
                              id: language === "hi" ? item : padtaalStaticHeadingsEng[index],
                              defaultMessage: language === "hi" ? item : padtaalStaticHeadingsEng[index]
                            })
                          })
                        })
                      })
                    }, item);
                  })
                })]
              }), index === 0 && size.width >= 600 && router.asPath.includes("election") && ((_electionStuff$3 = electionStuff[0]) === null || _electionStuff$3 === void 0 ? void 0 : _electionStuff$3.editorialBanner) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("img", {
                  width: "100%",
                  height: "300px",
                  src: (_electionStuff$4 = electionStuff[0]) === null || _electionStuff$4 === void 0 ? void 0 : _electionStuff$4.editorialBanner
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                  className: "news-card-box",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                    className: "news-card-body",
                    children: [index === 0 && (categoryName !== "factcheck" || categoryName === "factcheck" && size.width <= 499 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                      className: "cat-head-sec ".concat(size.width <= 500 ? "latest-cat-mob" : categoryName === "factcheck" ? "latest-cat-dtop" : ""),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("h1", {
                        className: "font-22-d title large px-3 px-md-0 mt-3 mt-md-0 ",
                        style: {
                          fontSize: "22px !important"
                        },
                        children: router !== null && router !== void 0 && router.pathname.includes("/featured") ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
                          id: "featured",
                          defaultMessage: "\u092B\u0940\u091A\u0930\u094D\u0921"
                        }) : router !== null && router !== void 0 && router.pathname.includes("/latest") ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                          children: language === "hi" ? "लेटेस्ट" : "Latest"
                        }) : categoryKeyword
                      }), !!(subCategoryItem !== null && subCategoryItem !== void 0 && subCategoryItem.length) && !(router !== null && router !== void 0 && router.pathname.includes("/featured")) && !(router !== null && router !== void 0 && router.pathname.includes("/latest")) && size.width >= 768 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.Fragment, {
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                          style: {
                            display: "flex",
                            gap: "5px"
                          },
                          className: "bg-inf",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                            ref: sliderRef,
                            style: {
                              display: "flex",
                              gap: "3px",
                              maxWidth: "500px",
                              overflowX: "hidden",
                              paddingRight: "20px"
                            },
                            className: "bg-succes",
                            children: subCategoryItem === null || subCategoryItem === void 0 ? void 0 : subCategoryItem.filter(function (subCatItem, index) {
                              return categoryName !== "election" || index < 5;
                            }).map(function (subCatItem) {
                              return (subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem.slug) != "naya-taaza" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                                className: "test-sub",
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
                                  className: (subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem.slug) === (query === null || query === void 0 ? void 0 : query.subCategoryName) ? "active" : "inactive",
                                  href: subCatsHref(subCatItem),
                                  passHref: true,
                                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(api_cleverTap__WEBPACK_IMPORTED_MODULE_18__/* .MyLink */ .Md, {
                                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("span", {
                                      children: [language === "hi" ? subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem.nameHn : subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem.name, " "]
                                    })
                                  })
                                })
                              }, subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem._id);
                            })
                          }), canScrollRight && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                            className: "slider-nav bg-dange",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                              onClick: scrollRight,
                              className: "prev",
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                                className: "swiper-circle",
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("i", {
                                  className: "icon-arrow-left swiper-icon-arrow"
                                })
                              })
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                              onClick: scrollLeft,
                              className: "next",
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                                className: "swiper-circle",
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("i", {
                                  className: "icon-arrow-right swiper-icon-arrow"
                                })
                              })
                            })]
                          })]
                        })
                      }), (router === null || router === void 0 ? void 0 : router.asPath) !== "/latest" && (router === null || router === void 0 ? void 0 : router.asPath) !== "/latest?type=all" && (router === null || router === void 0 ? void 0 : router.asPath) !== "/latest?type=text" && (router === null || router === void 0 ? void 0 : router.asPath) !== "/latest?type=video" && (router === null || router === void 0 ? void 0 : router.asPath) !== "/text/latest" && (router === null || router === void 0 ? void 0 : router.asPath) !== "/video/latest" && size.width < 768 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.Fragment, {
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                          style: {
                            display: "flex",
                            width: "95vw"
                          },
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                            ref: sliderRef,
                            style: {
                              display: "flex",
                              gap: "3px",
                              width: "100%",
                              overflowX: "scroll",
                              marginLeft: "-3%"
                            },
                            className: "mobile-subcat",
                            children: subCategoryItem === null || subCategoryItem === void 0 ? void 0 : subCategoryItem.filter(function (subCatItem, index) {
                              return categoryName !== "election" || index < 5;
                            }).map(function (subCatItem) {
                              return (subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem.slug) != "naya-taaza" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                                className: "test-sub",
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
                                  href: subCatsHref(subCatItem),
                                  passHref: true,
                                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(api_cleverTap__WEBPACK_IMPORTED_MODULE_18__/* .MyLink */ .Md, {
                                    className: (subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem.slug) === (query === null || query === void 0 ? void 0 : query.subCategoryName) ? "active" : "inactive",
                                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("span", {
                                      children: [language === "hi" ? subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem.nameHn : subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem.name, " "]
                                    })
                                  })
                                })
                              }, subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem._id);
                            })
                          }), (router === null || router === void 0 ? void 0 : router.asPath.includes("/factcheck")) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                            className: "right-side" // style={{ marginTop: "20px" }}
                            ,
                            children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
                              href: "https://ifcncodeofprinciples.poynter.org/profile/tv-today-network-limited",
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("a", {
                                children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("img", {
                                  src: "https://static.thelallantop.com/images/post/1713786729251_166a2699-7e1f-a8b0-8dff-d8eaf25ca394.webp" // height="75px"
                                  ,
                                  className: "fact-check-logo"
                                })]
                              })
                            })]
                          })]
                        })
                      })]
                    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                      className: "cat-head-sec factCheckDtop ".concat(size.width <= 500 ? "latest-cat-mob" : categoryName === "factcheck" ? "latest-cat-dtop" : ""),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                        className: "left-side",
                        children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("h1", {
                          className: "font-22-ds title large px-3 px-md-0 mt-3 mt-md-0 ",
                          style: {
                            fontSize: (size === null || size === void 0 ? void 0 : size.width) > 799 ? "22px !important" : "initial"
                          },
                          children: router !== null && router !== void 0 && router.pathname.includes("/featured") ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_37__/* ["default"] */ .Z, {
                            id: "featured",
                            defaultMessage: "\u092B\u0940\u091A\u0930\u094D\u0921"
                          }) : router !== null && router !== void 0 && router.pathname.includes("/latest") ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                            children: language === "hi" ? "लेटेस्ट" : "Latest"
                          }) : categoryKeyword
                        }), !!(subCategoryItem !== null && subCategoryItem !== void 0 && subCategoryItem.length) && !(router !== null && router !== void 0 && router.pathname.includes("/featured")) && !(router !== null && router !== void 0 && router.pathname.includes("/latest")) && size.width >= 500 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                          style: {
                            display: "flex",
                            flexDirection: "row"
                          },
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                            className: "subcate-sec ".concat(categoryName === "factcheck" ? "latest-cat-d" : ""),
                            style: {
                              width: "".concat(categoryName === "padtaal" ? "300px" : "600px")
                            },
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_7__/* .Swiper */ .tq, {
                              modules: [swiper__WEBPACK_IMPORTED_MODULE_11__/* .Navigation */ .W_],
                              navigation: {
                                prevEl: navprevRef.current,
                                nextEl: navnextRef.current
                              },
                              setWrapperSize: [true],
                              onBeforeInit: function onBeforeInit(swiper) {
                                swiper.params.navigation.prevEl = navprevRef.current;
                                swiper.params.navigation.nextEl = navnextRef.current;
                              },
                              breakpoints: {
                                0: {
                                  slidesPerView: 2,
                                  spaceBetween: 0
                                },
                                767: {
                                  slidesPerView: 2,
                                  spaceBetween: 0
                                },
                                991: {
                                  slidesPerView: 4,
                                  spaceBetween: 0
                                },
                                1199: {
                                  slidesPerView: 5,
                                  spaceBetween: 0
                                }
                              },
                              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                                className: "slider-nav",
                                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                                  ref: navprevRef,
                                  className: "prev",
                                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                                    className: "swiper-circle",
                                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("i", {
                                      className: "icon-arrow-left swiper-icon-arrow"
                                    })
                                  })
                                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                                  ref: navnextRef,
                                  className: "next",
                                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                                    className: "swiper-circle",
                                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("i", {
                                      className: "icon-arrow-right swiper-icon-arrow"
                                    })
                                  })
                                })]
                              }), subCategoryItem === null || subCategoryItem === void 0 ? void 0 : subCategoryItem.map(function (subCatItem) {
                                return (subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem.slug) != "naya-taaza" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_7__/* .SwiperSlide */ .o5, {
                                  className: "sub-list",
                                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                                    className: (subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem.slug) === (query === null || query === void 0 ? void 0 : query.subCategoryName) ? "active" : "inactive",
                                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
                                      // as={`/${query?.categoryName}/${subCatItem?.slug}`}
                                      // href={{
                                      //   pathname: `/${query?.categoryName}/${subCatItem?.slug}`,
                                      //   query: formSubcategoryQuery(
                                      //     subCatItem?._id
                                      //   ),
                                      // }}
                                      // passHref
                                      href: subCatsHref(subCatItem),
                                      passHref: true,
                                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(api_cleverTap__WEBPACK_IMPORTED_MODULE_18__/* .MyLink */ .Md, {
                                        onCustomClick: function onCustomClick() {
                                          var payload = {
                                            "Category Name": currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.name,
                                            "Category ID": currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory._id,
                                            "Sub Category Name": subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem.name
                                          }; // ClevertapReact.event(
                                          //   "homepage_categories",
                                          //   payload
                                          // );
                                        },
                                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("span", {
                                          children: [language === "hi" ? subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem.nameHn : subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem.name, " "]
                                        })
                                      })
                                    })
                                  }, subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem._id)
                                }, subCatItem === null || subCatItem === void 0 ? void 0 : subCatItem._id);
                              })]
                            })
                          })
                        }), " "]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                        className: "right-side" // style={{ marginTop: "20px" }}
                        ,
                        children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
                          href: "https://ifcncodeofprinciples.poynter.org/profile/tv-today-network-limited",
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("a", {
                            children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("img", {
                              src: "https://static.thelallantop.com/images/post/1713786729251_166a2699-7e1f-a8b0-8dff-d8eaf25ca394.webp" // height="75px"
                              ,
                              className: "fact-check-logo"
                            })]
                          })
                        })]
                      })]
                    })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                      className: "headline-wrap",
                      children: size.width > 600 ? oddnaariDesktop(categorizedNews, index) : oddnaariMobile(categorizedNews, index)
                    }, "".concat(index, "_index").concat(categoryKeyword))]
                  })
                }), index === 0 && (categorizedNewsArray === null || categorizedNewsArray === void 0 ? void 0 : categorizedNewsArray.length) >= 1 && router.asPath.includes("election") && subCategoryName === "lok-sabha-chunav-2024" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.Fragment, {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                    className: "electionYatra-outer",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                      className: "electionYatra-header",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("img", {
                          src: "/assets/images/election-icon.png",
                          width: "35px",
                          height: "35px",
                          alt: "election-icon"
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("span", {
                          style: {
                            marginLeft: "10px"
                          },
                          children: "\u091A\u0941\u0928\u093E\u0935 \u092F\u093E\u0924\u094D\u0930\u093E"
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                        className: "election-aurDekhe",
                        onClick: function onClick() {
                          return router.push("/topic/chunav-yatra-2024");
                        },
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("span", {
                          style: {
                            marginRight: "10px"
                          },
                          children: ["\u0914\u0930 \u0926\u0947\u0916\u0947\u0902", " "]
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("img", {
                          src: "/assets/images/arrow.png",
                          width: "10px",
                          height: "10px"
                        })]
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                      className: "electionYatra-columns",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
                        className: "checkMobileOrNot",
                        href: "".concat((_electionTopicData$ = electionTopicData[0]) === null || _electionTopicData$ === void 0 ? void 0 : _electionTopicData$.permalink),
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                          className: "electionYatra-second election-mobile",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                            className: "electionYatra-second-top",
                            style: {
                              position: "relative"
                            },
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("img", {
                              src: (_electionTopicData$2 = electionTopicData[0]) === null || _electionTopicData$2 === void 0 ? void 0 : _electionTopicData$2.headingImageUrl
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("i", {
                              className: "icon-play-circle",
                              width: "500px",
                              height: "500px",
                              style: {
                                color: "white",
                                position: "absolute",
                                left: "2px",
                                bottom: "-5px",
                                width: "500px"
                              }
                            })]
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                            className: "electionYatra-second-bottom",
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("h2", {
                              children: (_electionTopicData$3 = electionTopicData[0]) === null || _electionTopicData$3 === void 0 ? void 0 : _electionTopicData$3.title
                            })
                          })]
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                        style: {
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between"
                        },
                        children: electionTopicData.slice(1).map(function (x, index) {
                          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
                            href: "".concat(x === null || x === void 0 ? void 0 : x.permalink),
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                              className: "electionYatra-first",
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                                className: "electionYatra-first-div",
                                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                                  style: {
                                    // flex: "0 0 38%",
                                    position: "relative",
                                    justifyContent: "center",
                                    alignContent: "center",
                                    alignItems: "center"
                                  },
                                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("img", {
                                    src: x === null || x === void 0 ? void 0 : x.headingImageUrl,
                                    width: "160px",
                                    height: "90px"
                                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("i", {
                                    className: "icon-play-circle",
                                    style: {
                                      color: "white",
                                      position: "absolute",
                                      left: "2px",
                                      bottom: "-5px"
                                    }
                                  })]
                                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                                  className: "electionYatra-first-div-right",
                                  style: {
                                    flex: "0 0 60%"
                                  },
                                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                                      style: {
                                        overflow: "hidden"
                                      },
                                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                                        style: {
                                          display: "-webkit-box",
                                          lineHeight: "22px",
                                          WebkitLineClamp: "3",
                                          WebkitBoxOrient: "vertical",
                                          marginTop: "5px"
                                        },
                                        className: "chunav-yatra-small-title",
                                        children: x === null || x === void 0 ? void 0 : x.title
                                      })
                                    })
                                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                                    style: {
                                      display: "flex",
                                      gap: "1rem"
                                    }
                                  })]
                                })]
                              })
                            })
                          }, index);
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
                        className: "checkDesktopOrNot",
                        style: {
                          width: "100%"
                        },
                        href: "".concat((_electionTopicData$4 = electionTopicData[0]) === null || _electionTopicData$4 === void 0 ? void 0 : _electionTopicData$4.permalink),
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                          className: "electionYatra-second election-desktop",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                            className: "electionYatra-second-top",
                            style: {
                              position: "relative"
                            },
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("img", {
                              src: (_electionTopicData$5 = electionTopicData[0]) === null || _electionTopicData$5 === void 0 ? void 0 : _electionTopicData$5.headingImageUrl
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("i", {
                              className: "icon-play-circle",
                              width: "500px",
                              height: "500px",
                              style: {
                                color: "white",
                                position: "absolute",
                                left: "2px",
                                bottom: "-5px",
                                width: "500px"
                              }
                            })]
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                            className: "electionYatra-second-bottom",
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("h2", {
                              children: (_electionTopicData$6 = electionTopicData[0]) === null || _electionTopicData$6 === void 0 ? void 0 : _electionTopicData$6.title
                            })
                          })]
                        })
                      })]
                    })]
                  })
                }), index === 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
                  align: "center",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                    className: "container-row py-2",
                    align: "center",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("p", {
                      style: {
                        fontSize: "11px",
                        color: "#b7b7b7",
                        textAlign: "center",
                        marginBottom: "0px"
                      },
                      children: "Advertisement"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                      id: size.width > 600 ? "div-gpt-ad-1701945220410-1" : "div-gpt-ad-1701946028239-1",
                      style: {
                        minWidth: "300px",
                        minHeight: "100px",
                        display: "block !important",
                        alignContent: "center",
                        textAlign: "-webkit-center"
                      },
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                          __html: size.width > 600 ? "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-1')})" : "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})"
                        }
                      })
                    })]
                  }), " "]
                }), index === 1 && (categorizedNewsArray === null || categorizedNewsArray === void 0 ? void 0 : categorizedNewsArray.length) >= 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
                  align: "center",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsxs)("div", {
                    className: "container-row py-2",
                    align: "center",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("p", {
                      style: {
                        fontSize: "11px",
                        color: "#b7b7b7",
                        textAlign: "center",
                        marginBottom: "0px"
                      },
                      children: "Advertisement"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                      id: size.width > 600 ? "div-gpt-ad-1701945220410-2" : "div-gpt-ad-1701946028239-2",
                      style: size.width > 600 ? {
                        minWidth: "300px",
                        minHeight: "100px",
                        display: "block !important",
                        alignContent: "center",
                        textAlign: "-webkit-center"
                      } : {
                        minWidth: "300px",
                        minHeight: "260px",
                        display: "block !important",
                        alignContent: "center",
                        textAlign: "-webkit-center"
                      },
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                          __html: size.width > 600 ? "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-2')})" : "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-2')})"
                        }
                      })
                    })]
                  }), " "]
                }), adPlacement970_250 && !!((_Object$keys = Object.keys(adPlacement970_250[index] || {})) !== null && _Object$keys !== void 0 && _Object$keys.length) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
                  className: "sponser-card no-bg s-970x250",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("a", {
                    href: adPlacement970_250 && ((_adPlacement970_250$i = adPlacement970_250[index]) === null || _adPlacement970_250$i === void 0 ? void 0 : _adPlacement970_250$i.redirect_url) || "#",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("img", {
                      src: adPlacement970_250 && ((_adPlacement970_250$i2 = adPlacement970_250[index]) === null || _adPlacement970_250$i2 === void 0 ? void 0 : _adPlacement970_250$i2.image_url),
                      alt: "ads"
                    })
                  })
                })]
              }, "".concat(index, "_index"))]
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(pages_404__WEBPACK_IMPORTED_MODULE_12__["default"], {})
        }, index);
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(components_faq__WEBPACK_IMPORTED_MODULE_21__["default"], {
      data: faqData
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_36__/* ["default"] */ .Z, {
      align: "center"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_28__.jsx)("div", {
      id: "taboola-below-category-thumbnails"
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (CommonCategoryPage);

/***/ })

}]);